import { render, staticRenderFns } from "./noticeSetting.vue?vue&type=template&id=204984f3&scoped=true&"
import script from "./noticeSetting.vue?vue&type=script&lang=js&"
export * from "./noticeSetting.vue?vue&type=script&lang=js&"
import style0 from "./noticeSetting.vue?vue&type=style&index=0&id=204984f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204984f3",
  null
  
)

export default component.exports